<a href="#" (click)="clickEvent($event)" class="nav-link toggle-bar"
  [ngClass]="{ toggled: toggled, primary: isPrimary }" (blur)="blurEvent()">
  <em class="fa fa-fw fa-bars"></em>
</a>
